import React from 'react'
import RichTextEditor from '@/shared/RichTextEditor'

// Long-form editor with image upload for members who have it.
const TipTapProject = (props) => <RichTextEditor variant='document' {...props} />

export default TipTapProject
